import { useEffect, useRef } from 'react'

// This is an arbitrary (best estimate) threshold to determine if the virtual keyboard is visible.
// There's no good way of finding the keyboard height.
const OFFSET_THRESHOLD = 100

export const useVirtualKeyboardVisibilityRef = () => {
  const keyboardVisibilityRef = useRef(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.visualViewport.offsetTop > OFFSET_THRESHOLD) {
        keyboardVisibilityRef.current = true
      } else {
        keyboardVisibilityRef.current = false
      }
    }
    window.visualViewport.addEventListener('resize', handleResize)

    return () => {
      window.visualViewport.removeEventListener('resize', handleResize)
    }
  }, [])

  return keyboardVisibilityRef
}
